import { leadersDirectoryAllPageUrl } from '@ms/yammer-web-support/dist/urls';
import { matchPath, useLocation } from 'react-router-dom';

export const useIsLeadersDirectoryAllPage = (): boolean => {
  const pathname = useLocation()?.pathname ?? '';

  return !!matchPath(pathname, { path: leadersDirectoryAllPageUrl });
};
